import { useContext } from 'react';
import {
  SnackBarContext,
  SnackBarContextType
} from 'src/contexts/snackbar-context';

export const useSnackBar = () =>
  useContext<SnackBarContextType>(SnackBarContext);
